import React, { useRef, useState } from "react";
import { Helmet } from "react-helmet";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import useSWR from "swr";
import { API } from "../../../StoreComponents/conflict";

const fetcher = (url) => API.get(url).then((res) => res.data.data);
const fetcher1 = (url) =>
  API.get(url, {
    headers: {
      search: `%%`,
    },
  }).then((res) => res.data.data);
const StockStatusCategory = () => {
  const [openElement, setOpenElement] = useState(false);
  const [printButton, setPrintButton] = useState(false);
  const [typeError, setTypeError] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");

  const {
    data: allEnties,
    error,
    mutate,
  } = useSWR(
    selectedCategory
      ? `store/reports/stockStatus?queryFor=category&categoryid=${selectedCategory}`
      : null,
    fetcher
  );
  console.log(allEnties);
  // console.log(selectedCategory);
  // get categoryData
  const { data: categoryOption, error: error2 } = useSWR(
    `store/settings/categories?page=${0}&limit=${10000}`,
    fetcher1
  );

  // toggle seach button
  const handleToggle = () => {
    if (!selectedCategory) {
      setTypeError("field Required");
      setOpenElement(false);
      setPrintButton(false);
    } else {
      setOpenElement(true);
      setPrintButton(true);
    }
  };

  // handle Category select;
  const handleCategory = (name) => {
    setSelectedCategory(name.value);
  };

  // set category select list
  let category = [];
  if (categoryOption && categoryOption.length > 0) {
    category = categoryOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.cat_id;
      optionsItem.label = `${data.categoryen} (${data.categorybn})`;
      return optionsItem;
    });
  }

  // print
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <Helmet>
        <title>All Products - BBA STORE</title>
        <meta name="description" content="Product List - BBA STORE" />
      </Helmet>

      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h1></h1>
            <button
              onClick={handlePrint}
              type="button"
              className={
                printButton
                  ? "btn btn-color px-3 printBtn show"
                  : "printBtn btn btn-danger px-3"
              }
            >
              <i className="fa fa-print"></i>
              <span> Print</span>
            </button>
          </div>

          {/* Seach Element */}
          <div className="category show">
            <div className="mx-auto">
              <div className="add_category text-center">
                <div className="row mx-3">
                  <div className="col-12 col-md-6 col-lg-6">
                    <label htmlFor="product_category">
                      Category <span className="color-red">*</span>
                    </label>
                    <Select
                      onChange={handleCategory}
                      style={{ borderRadius: "10px" }}
                      className="text-start fs-6"
                      options={category}
                    />
                    <p className="text-start text-danger">
                      {selectedCategory ? "" : typeError}
                    </p>
                  </div>
                </div>
                <br />
                <button
                  onClick={handleToggle}
                  type="button"
                  className="mt-3 px-5 btn btn-color_store"
                >
                  <i className="fa fa-search"></i>
                  <span> Search</span>
                </button>
              </div>

              {/* Search Result */}
              {allEnties ? (
                <div
                  ref={componentRef}
                  className={
                    openElement
                      ? "category show my-4 table-container p-2"
                      : "category my-4 table-container p-2"
                  }
                  style={{ background: "white", borderRadius: "10px" }}
                >
                  <div className="text-center mt-4 mb-5">
                    <div>
                      <h4>
                        <b>INFOTECH IT SOLUTIONS</b>
                      </h4>

                      <h3>দ্রব্য লগ</h3>
                      <h4>Current Product Status</h4>
                      <h5>
                        Category : {allEnties[0] ? allEnties[0].CATEGORYEN : ""}
                      </h5>
                    </div>
                  </div>
                  <div className="table-responsive-sm">
                    <table className="table table-bordered table-striped boder">
                      <thead>
                        <tr className="text-center">
                          <th className=" col-design1" colSpan="1">
                            S/N
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Category
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Product
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Unit
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Total IN
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Total OUT
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Current Stock
                          </th>
                        </tr>
                      </thead>
                      {allEnties && (
                        <tbody>
                          {allEnties.map((product, index) => (
                            <tr key={index}>
                              <th className="text-center col-design1">
                                {index + 1}
                              </th>
                              <td className="text-start col-design1">
                                {product.CATEGORYEN}
                              </td>
                              <td className="text-start col-design1">
                                {product.PRONAME} <br />
                                {product.PRONAMETWO}
                              </td>
                              <td className="text-start col-design1">
                                {product.UNIT}
                              </td>
                              <td className="text-center col-design1">
                                {product.TOTAL + product.PROQTY}
                              </td>
                              <td className="text-center col-design1">
                                {product.TOTAL}
                              </td>
                              <td className="text-center col-design1">
                                {product.PROQTY}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          {/* Seach Element */}
        </div>
      </div>
    </>
  );
};

export default StockStatusCategory;
